<template>
    <v-app id="inspire">
        <v-content>
            <v-container
                fluid
                fill-height
            >
                <v-layout
                    align-center
                    justify-center
                >
                    <v-flex
                        xs12
                        sm8
                        md4
                    >
                        <div style="width: 100%; text-align: center; height: 150px;">
                            <img style="height: 150px; width: auto;" :src=" '/static/'+$root.app_meta.app_folder + '/logo_empresa.png'">
                        </div>
                        <v-card class="elevation-12">
                            <v-toolbar
                                dark
                                color="primary"
                            >
                                <v-toolbar-title>Iniciar sesión</v-toolbar-title>
                                <v-spacer/>
                            </v-toolbar>
                            <v-card-text>
                                <v-form>
                                    <v-text-field
                                        v-model="form.email"
                                        prepend-icon="mdi-account"
                                        name="login"
                                        label="Correo"
                                        type="email"
                                    />
                                    <v-text-field
                                        id="password"
                                        v-model="form.password"
                                        prepend-icon="mdi-lock"
                                        name="password"
                                        label="Contraseña"
                                        type="password"
                                        @keyup.enter="iniciarSesion"
                                    />
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                    color="gray"
                                    @click="dialog = true"
                                >
                                    Recuperar contraseña
                                </v-btn>
                                <v-spacer/>
                                <v-btn
                                    :loading="loading"
                                    color="primary"
                                    @click="iniciarSesion"
                                >
                                    Iniciar sesión
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-snackbar
                    v-model="snackbar"
                    rigth
                    top
                    :color="snackbar_config.color"
                    :multi-line="snackbar_config.multi_line"
                    :timeout="snackbar_config.timeout"
                    :vertical="snackbar_config.mobile"
                >
                    <div v-html="snackbar_config.text_content"/>
                    <v-btn
                        dark
                        @click="snackbar = false"
                    >
                        Cerrar
                    </v-btn>
                </v-snackbar>
                <v-dialog
                    v-model="dialog"
                    persistent
                    max-width="600px"
                >
                    <v-card>
                        <v-card-title>
                            <span class="headline">Recuperar contraseña</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout
                                    wrap
                                    form
                                >
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model.trim="email_recovery"
                                            label="Correo electrónico"
                                            required
                                            @keyup.enter="recuperarPassword"
                                        />
                                    </v-flex>
                                </v-layout>
                                <small>Escribe el correo con el que inicias sesión normalmente</small>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn
                                color="gray darken-1"
                                @click="dialog = false"
                            >
                                Cancelar
                            </v-btn>
                            <v-btn
                                color="blue darken-1"
                                :loading="loading"
                                dark
                                @click="recuperarPassword"
                            >
                                Recuperar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-container>
        </v-content>
    </v-app>
</template>
<script>
    import axios from 'axios';

    export default {
        name: "Login",
        data() {
            return {
                form: {
                    email: '',
                    password: ''
                },
                loading: false,
                dialog: false,
                email_recovery: ''
            }
        },
        methods: {
            iniciarSesion() {
                this.loading = true;
                axios.post('api/auth/login', this.form)
                    .then((response) => {
                        this.loading = false;
                        let {data} = response;
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.data.access_token;
                        this.$root.is_auth = true;
                        this.$root.token = data.data.access_token;
                        localStorage.setItem('token', data.data.access_token);
                        this.$router.push({
                            name: 'home'
                        });
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.snackbar_config.color = 'error';
                        this.snackbar = true;
                        this.snackbar_config.timeout = 6000;
                        if (error.response) {
                            if (error.response.data.message) {
                                this.snackbar_config.text_content = error.response.data.message;
                            }

                            if (error.response.status === 422) {
                                this.snackbar_config.text_content += '<br>';
                                if ((Object.getOwnPropertyNames(error.response.data.data)).length) {
                                    for (let item in error.response.data.data) {
                                        this.snackbar_config.text_content += (error.response.data.data[item]).join(',') + '<br>';
                                    }
                                }
                            }
                            return;
                        }

                        this.snackbar_config.text_content = 'Error durante la petición';
                    })
            },
            recuperarPassword() {
                this.loading = true;
                axios.post('/api/app/password/custom-reset-create', {email: this.email_recovery})
                    .then((responseOk) => {
                        this.loading = false;
                        this.snackbar_config.color = 'success';
                        this.snackbar = true;
                        this.snackbar_config.timeout = 6000;
                        this.snackbar_config.text_content = responseOk.data.message;
                        this.dialog = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.snackbar_config.color = 'error';
                        this.snackbar = true;
                        this.snackbar_config.timeout = 6000;
                        if (error.response) {

                            if (error.response.data.message) {
                                this.snackbar_config.text_content = error.response.data.message;
                            }

                            if (error.response.status === 422) {
                                this.snackbar_config.text_content += '<br>';
                                if ((Object.getOwnPropertyNames(error.response.data.data)).length) {
                                    for (let item in error.response.data.data) {
                                        this.snackbar_config.text_content += (error.response.data.data[item]).join(',') + '<br>';
                                    }
                                }
                            }
                            return;
                        }

                        this.snackbar_config.text_content = 'Error durante la petición';
                    });
            }
        }
    }
</script>

<style scoped>

</style>
